import React from 'react';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { isTwoGisEnabled } from 'Douleutaras/configuration/twoGis';
import { Gis } from 'Douleutaras/components/Forms/gis.class';
import { CityBounds, GoogleAutocompleteField } from 'Douleutaras/components/Forms/Fields/GoogleAutocompleteField';
import { TwoGisAutocompleteField } from 'Douleutaras/components/Forms/Fields/TwoGisAutocompleteField';

interface AddressAutocompleteFieldProps {
  input: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
    >;
  bounds?: CityBounds;
  children?: React.ReactElement;
  handleKeyDown?(event): void;
  onChange(gis: Gis): void;
}

/**
 * Picks the map/geocoding provider for the address autocomplete based on the country:
 * 2GIS for Cyprus (Google Maps has poor coverage there), Google everywhere else. The
 * two providers expose the same `input`/`onChange` contract to callers.
 */
export const AddressAutocompleteField = (props: AddressAutocompleteFieldProps) => {
  const { countryCode } = useLocalization();

  if (isTwoGisEnabled(countryCode)) {
    return <TwoGisAutocompleteField input={props.input}
                                    onChange={props.onChange}
    >
      {props.children}
    </TwoGisAutocompleteField>;
  }

  return <GoogleAutocompleteField {...props} />;
};
